// extracted by mini-css-extract-plugin
export default {"count_cards_container":"countCards_count_cards_container__O9GP0","count_card":"countCards_count_card__45iLY","count_info":"countCards_count_info__Kek5C"};